/**
 * The install invitation.
 *
 * Shown once and dismissible. Nagging about this would be its own kind of friction, but it is
 * worth asking clearly at least once: on iOS nothing else can deliver a reminder, because
 * push only reaches a PWA that lives on the Home Screen.
 */

import { useEffect, useState } from 'preact/hooks';

import {
  detectEnvironment,
  installState,
  offerInstall,
  watchForInstallPrompt,
} from '../pwa/install';

const DISMISSED = 'shelf-aware.install-dismissed';

export function InstallInvitation() {
  const [state, setState] = useState(() => installState(detectEnvironment()));
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISSED) === 'yes');

  useEffect(() => watchForInstallPrompt(() => setState(installState(detectEnvironment()))), []);

  if (dismissed || state === 'installed' || state === 'unavailable') {
    return null;
  }

  const dismiss = (): void => {
    localStorage.setItem(DISMISSED, 'yes');
    setDismissed(true);
  };

  return (
    <aside class="install">
      <div>
        <strong>Add to your Home Screen</strong>
        <p>
          {state === 'manual'
            ? 'Tap Share, then “Add to Home Screen”. Reminders about food going off can only reach you once it is there.'
            : 'It opens faster, works without a signal, and can remind you when something needs using.'}
        </p>
      </div>

      <div class="install-actions">
        {state === 'promptable' ? (
          <button
            type="button"
            class="primary"
            onClick={() => {
              void offerInstall().then(() => setState(installState(detectEnvironment())));
            }}
          >
            Add
          </button>
        ) : null}
        <button type="button" onClick={dismiss}>
          Not now
        </button>
      </div>
    </aside>
  );
}
